module.exports = __webpack_public_path__ + "static/img/bg_ldy_shuju.a24d19c5.png";